import type { RegionEvent } from "@/types/geodata";

export function EventList({ events }: { events: RegionEvent[] }) {
  return (
    <div className="rounded-md border bg-card p-3">
      <p className="text-xs uppercase text-muted-foreground">Notable events</p>
      <div className="mt-3 space-y-3">
        {events.map((event) => (
          <article key={event.id} className="border-t border-white/10 pt-3 first:border-t-0 first:pt-0">
            <div className="flex items-start justify-between gap-3">
              <h3 className="text-sm font-semibold">{event.title}</h3>
              <span className="text-xs text-red-200">+{event.pressureDelta}</span>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">{event.summary}</p>
            <p className="mt-2 text-xs text-amber-200">{event.source}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
